import React, { FC, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import { NoAccess } from './auth/noAccess';
import ProjectContainer from './project/project-container';
import { useProjects } from '../../loaders/useProjects';
import { useParams } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import { SearchBox } from './search/SearchBox';
import { useSearch } from './search/SearchV2Context';
import { usePageTitle } from './pageTitleContext/PageTitleContext';

export const Publisher: FC = observer(() => {

    const { show, toggleShow } = useSearch();

    const { projectId } = useParams() as { projectId: string };
    const useProjectsResult = useProjects(projectId);
    const authUser = useAuthUser();
    const { setPageTitle } = usePageTitle();

    setPageTitle();

    const handleClose = () => toggleShow();

    function isAnyInputFocused() {
        const el = document.activeElement;
        return (
            el &&
            (el.tagName === 'INPUT' ||
                el.tagName === 'TEXTAREA' ||
                el.tagName === 'SELECT')
        );
    }

    const handleKeyPress = useCallback((event: any) => {

        if (event.key === '/') {
            if (isAnyInputFocused())
                return;

            event.preventDefault();
            toggleShow();
        }
    }, [toggleShow]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    return (
        <>
            {!useProjectsResult.isLoaded
                ? <CustomSpinner spinnerText="Loading projects..." />
                : authUser?.isAuthorisedForHostedToolProject(projectId)
                    ? <ProjectContainer />
                    : <NoAccess />
            }
            <Offcanvas show={show} onHide={handleClose} placement={'end'}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title><i className="fas fa-search" /> Search configurations</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <SearchBox />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
});

